export const FETCH_AUTOCOMPLETE_USERS_RESOLVED =
  "FETCH_AUTOCOMPLETE_USERS_RESOLVED";
